import type { FieldProps } from './TextField';
import { useFormField } from '../../hooks/useFormField';
import { QuestionWrapper } from '../QuestionWrapper';

export function EmailField({ fieldSchema, group }: FieldProps) {
  const field = useFormField(fieldSchema, group);

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group">
        <div className="answer">
          <input
            type="text"
            className="text"
            value={String(field.answer ?? '')}
            onChange={(e) => field.setAnswer(e.target.value)}
            name={field.question.id}
            id={`input-${field.question.id}`}
          />
        </div>
      </div>
    </QuestionWrapper>
  );
}
